module.exports = require('./JSResource')
